exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*  EDITABLE TABLE */\n.editable-table td {\n    outline: none !important;\n}\n\n.editable-table + input, .editable-table input:focus {\n    border: 1px solid #0190fe !important;\n    outline: 0 !important;\n    outline-offset: 0 !important;\n    box-sizing: content-box;\n}\n\n.editable-table.table-inverse + input, .editable-table.table-inverse input:focus {\n    border-color: #d2d9e5 !important;\n    border-bottom: none !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/node_modules/postcss-loader?{"ident":"postcss"}!F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/assets/modules/vendors/editable-table/editable-table.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/modules/vendors/editable-table/editable-table.css
// module chunks = styles